import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import styles from './../SuperSearch.module.css';
import isNull from "../../../../utils/NullChecking";
const SuperSearchMultipleClient = (props) => {
  const {
    ItemLists,
    options,
    searchParam,
    setSearchParam,
    initialSelectedValues,
    selectedOptionsDisplay,
    name,
    AddNew,
    handleAddNew,
    view,
    isOpenList,
    inputError,
    primaryRoleId
  } = props;

  const [selectedOptions, setSelectedOptions] = useState(initialSelectedValues);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [isListOpen, setIsListOpen] = useState(isOpenList ? isOpenList : false);
  const [buttonWidth, setButtonWidth] = useState(0);

  const listRef = useRef(null);
  const buttonRef = useRef(null);
  const inputRef = useRef(null);
  const inputRef3 = useRef(null);
  const parentRef = useRef(null);

  const onSelect = (selectedDataArray, name) => {
    let modal = { ...searchParam };
    if (selectedDataArray.length > 0) {
      const valueValues = selectedDataArray.map(data => data.value);
      modal[name] = valueValues.join(', ');
    } else {
      modal[name] = '';
    }
    setSearchParam(modal);
  };

  useEffect(() => {
    const filteredItems = options?.filter(item => item.value !== -1);
    setFilteredOptions(filteredItems);
  }, [options]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (parentRef.current && !parentRef.current.contains(event.target)) {
        setIsListOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    getWidth();
  }, [selectedOptions]);

  useEffect(() => {
    if (isListOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isListOpen]);

  const handleToggleOption = (option) => {
    ResetOption();
    const isSelected = selectedOptions.some((selected) => selected.value === option.value);
    let data = [];
    if (isSelected) {
      data = selectedOptions.filter((selected) => selected.value !== option.value);
    } else {
      data = [...selectedOptions, option];
    }
    setSelectedOptions(data);
    onSelect(data, name);
  };

  const handleClearOptions = () => {
    setSelectedOptions([]);
    onSelect([], name);
  };

  const handleSearch = (event) => {
    const term = event.target.value;
    if (!isNull(term)) {
      setSearchTerm(term);
      const filtered = options.filter((option) =>
        option.display?.toLowerCase().includes(term.toLowerCase())
      );
      setFilteredOptions(filtered);
    } else {
      setSearchTerm(term);
      setFilteredOptions(options);
    }
  };

  const ResetOption = () => {
    setSearchTerm('');
    setFilteredOptions(options);
    handleSpanClick();
  };

  const getWidth = () => {
    if (buttonRef.current) {
      setButtonWidth(buttonRef.current.offsetWidth + 10);
    }
  };

  const handleSpanClick = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const handleFirstInputClick = (e) => {
    e.preventDefault();
    setIsListOpen(!isListOpen);
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const handleStatusColor = (status) => {
    switch (status) {
      case "Awaiting Response": return "Hold-clr";
      case "Submitted": return "Submitted-clr";
      case "Merged": return "Paid-clr";
      case "Rejected": return "Rejected-clr";
      case "Not Sent": return "ar-light-color";
      default: return "Submitted-clr";
    }
  };

  // ✅ Handle Select All
  const handleSelectAll = () => {
    if (selectedOptions.length === filteredOptions.length) {
      setSelectedOptions([]);
      onSelect([], name);
    } else {
      setSelectedOptions(filteredOptions);
      onSelect(filteredOptions, name);
    }
  };

  useEffect(() => {
    console.log(initialSelectedValues, 'initialSelectedValues', name);

    if (initialSelectedValues && initialSelectedValues.length > 0) {
      setSelectedOptions(initialSelectedValues);
    }
  }, [initialSelectedValues]);
  console.log(selectedOptions, 'initialSelectedValues', filteredOptions);


  useEffect(() => {
    if (!Array.isArray(selectedOptions)) return;
    if (primaryRoleId === null || primaryRoleId === undefined) return;

    // ✅ Filter from CURRENT selectedOptions, not initial
    const hasPrimaryRole = selectedOptions.some(
      item => Number(item.value) === Number(primaryRoleId)
    );

    if (hasPrimaryRole) {
      const filtered = selectedOptions.filter(
        item => Number(item.value) !== Number(primaryRoleId)
      );
      setSelectedOptions(filtered);
      onSelect(filtered, name);
    }
  }, [primaryRoleId]); // ✅ Only depend on primaryRoleId


  // Body scroll-lock effect — fixed
  useEffect(() => {
    if (!props?.ScrollOutside) return;
    if (!listRef?.current || !(filteredOptions?.length > 0)) return;

    const handleWheel = (e) => {
      if (!listRef.current.contains(e.target)) {
        e.preventDefault();
      }
    };
    if (isListOpen) {
      document.body.style.overflow = "hidden";
      document.addEventListener("wheel", handleWheel, { passive: false });
    } else {
      document.body.style.overflow = "auto";
      document.removeEventListener("wheel", handleWheel);
    }
    return () => {
      document.body.style.overflow = "auto";
      document.removeEventListener("wheel", handleWheel);
    };
  }, [filteredOptions, isListOpen]);

  // Positioning state
  const [divStyle, setDivStyle] = useState(() => props.ScrollOutside ? { visibility: 'hidden' } : {});

  const updateDropdownPosition = () => {
    if (!parentRef.current || !listRef.current) return;

    const rect = parentRef.current.getBoundingClientRect();
    const dropdownHeight = listRef.current.offsetHeight;
    const dropdownWidth = listRef.current.offsetWidth;
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;

    let top = rect.bottom;
    let left = rect.left;

    if (rect.bottom + dropdownHeight > viewportHeight) {
      top = rect.top - dropdownHeight;
    }
    if (rect.left + dropdownWidth > viewportWidth) {
      left = viewportWidth - dropdownWidth - 10;
    }
    if (left < 0) left = 10;

    setDivStyle({
      top: `${top}px`,
      left: `${left}px`,
      width: `${rect.width}px`,
      position: 'fixed',
      zIndex: 9999,
      visibility: 'visible',
    });
  };

  const positionDropdown = () => {
    if (!props.ScrollOutside) return;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        updateDropdownPosition();
      });
    });
  };

  useLayoutEffect(() => {
    if (!props.ScrollOutside) return;

    if (isListOpen) {
      updateDropdownPosition();

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
          updateDropdownPosition();
        });
      }

      const rafId = requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          updateDropdownPosition();
        });
      });

      return () => cancelAnimationFrame(rafId);
    } else {
      setDivStyle(prev => ({ ...prev, visibility: 'hidden' }));
    }
  }, [isListOpen, filteredOptions]);

  useEffect(() => {
    if (!props.ScrollOutside) return;
    const handleResize = () => positionDropdown();
    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', handleResize, true);
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', handleResize);
    };
  }, [props.ScrollOutside]);

  return (
    <div className={`${styles.sup_auto_suggest} ${styles.insurance_auto} ar-super-serach-multiple`} ref={parentRef}>
      <div className={'selected_options'} ref={buttonRef} onClick={() => setIsListOpen(!isListOpen)}>
        {view === 'MultiOptions' ? (
          <>
            {selectedOptions?.length > 0 &&
              selectedOptions.map(option => (
                <div key={option.value} className='d-flex align-items-center ar-selected ar-selected-bg'>
                  <p className='text fs-10 font-m validation_message text-nowrap'>{option?.display}</p>
                  <i className="icon-Group-3311" onClick={(e) => { e.stopPropagation(); handleToggleOption(option); }}></i>
                </div>
              ))}
          </>
        ) : (
          selectedOptions?.length > 0 && (
            selectedOptions?.length === 1 ? (
              <>
                <p className='heading font-m options fst-italic text-nowrap validation_message'>{selectedOptions?.[0]?.display}</p>
                <i className='icon-Group-3311' onClick={(e) => { e.stopPropagation(); handleClearOptions(); }}></i>
              </>
            ) : selectedOptions?.length > 1 ? (
              <div className='d-flex justify-content-between align-items-center w-88'>
                <p className='heading font-m options fst-italic text-nowrap validation_message'>
                  {selectedOptions?.length} {selectedOptionsDisplay}(s) selected
                </p>
                <i className='icon-Group-3311' onClick={(e) => { e.stopPropagation(); handleClearOptions(); }}></i>
              </div>
            ) : null
          )
        )}
      </div>

      <div className={`${styles.sup_auto_suggest} ${styles.insurance_auto} ar-options-list`}>
        <div className={`input-group ar-search-arrow ${styles[props.sup_inp]} ${inputError ? 'input error' : ''}`}>
          <input onMouseDown={handleFirstInputClick} onFocus={(e) => e.target.blur()} />
          {isListOpen ? (
            <i className='icon-caret-up' onClick={() => setIsListOpen(!isListOpen)}></i>
          ) : (
            <i className='icon-caret-down' onClick={() => setIsListOpen(!isListOpen)}></i>
          )}

          {isListOpen && (
            <div ref={listRef} className={`${styles.sup_listWrapper} ${styles.insurance_list_wrap} hk-supListBOX ${props?.ScrollOutside ? '' : 'mt-4'}`} style={divStyle}>
              <ul className="list-group" id="ul-list-for-auto">
                <div className="hk-SchedulerList__body__searchBar">
                  <i className="bi bi-search "></i>
                  <input
                    type="text"
                    className='border-0'
                    placeholder="Search..."
                    onChange={handleSearch}
                    value={searchTerm}
                    ref={inputRef}
                  />
                </div>

                <div className='ar-optiins-list'>
                  {/* ✅ Select All Option */}
                  {filteredOptions?.length > 0 && (
                    <li
                      className={`${styles.sup_list_group_item} ${selectedOptions.length === filteredOptions.length ? "ar-slected-list" : ""}`}
                      onClick={handleSelectAll}
                    >
                      <div className='d-flex justify-content-between align-items-center ar-all-options'>
                        <div className='d-flex align-items-center gap-2'>
                          <i className={`icon-check fs-14 ${selectedOptions.length === filteredOptions.length ? 'opacity-100' : 'opacity-0'}`}></i>
                          <p className='text'>Select All</p>
                        </div>
                      </div>
                    </li>
                  )}

                  {/* ✅ Regular options */}
                  {filteredOptions?.map((option) => (
                    <li
                      className={`${styles.sup_list_group_item} ${selectedOptions?.some(op => op.value === option.value) ? styles.sup_DU : ''} ${selectedOptions?.some(op => op.value === option.value) ? "ar-slected-list" : ''}`}
                      key={option.value}
                      onClick={() => handleToggleOption(option)}
                    >
                      <div className='d-flex justify-content-between align-items-center ar-all-options'>
                        <div className='d-flex align-items-center gap-2'>
                          <i className={`icon-check fs-14 ${selectedOptions?.some(op => op.value === option.value) ? 'opacity-100' : 'opacity-0'}`}></i>
                          <p className='text'>
                            <SearchLetterHighlighted classes={'text'} searchValue={searchTerm} text={option.display} />
                          </p>
                        </div>
                        {!isNull(option.color) ? <div className={`${'ar_chekbox-circle me-0 '}${option?.color}`}></div> : null}
                        {!isNull(option.ColorCode) ? <div className='ar_chekbox-circle me-0' style={{ backgroundColor: option?.ColorCode }}></div> : null}
                      </div>
                    </li>
                  ))}

                  {AddNew && filteredOptions.length === 0 && (
                    <div className='za-add-CT d-flex gap-1 justify-content-center align-items-center'>
                      <i className='icon-plus-feesetup fs-11'></i>
                      <div className='text font-m fs-11 za-blue-clr text-decoration-underline cursor-pointer' onClick={() => handleAddNew(searchTerm)}>
                        Click to Add {selectedOptionsDisplay}
                      </div>
                    </div>
                  )}
                </div>
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SuperSearchMultipleClient;

// ✅ Highlight component stays the same
export const SearchLetterHighlighted = ({ classes, text, searchValue }) => {
  if (!text || text?.length <= 0) return;

  const escapeRegExp = (string) => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const highlightText = (text, search) => {
    if (!search.trim()) return [text];
    const escapedSearch = escapeRegExp(search);
    const regex = new RegExp(`(${escapedSearch})`, 'gi');
    return text.split(regex).map((part, index) =>
      regex.test(part)
        ? <span className='orange-clr' key={index}>{part}</span>
        : part
    );
  };

  const segments = highlightText(text, searchValue);
  return (
    <p className={classes} title={text}>
      {segments}
    </p>
  );
};
